/**
 * The Capiche User Community — a Facebook group for people who use Capiche.
 *
 * Single source of truth. Consumed by the web-app header (CSW-1671) and the
 * teacher-portal guide (CSW-1670, which re-exports this), so the URL is never
 * copied into more than one place and left to drift.
 */
export const CAPICHE_COMMUNITY_URL = 'https://www.facebook.com/groups/1467340168535835/';

/** One-line "what/why" shown on the community prompt (web-app menu card + teacher-portal card). */
export const CAPICHE_COMMUNITY_BLURB =
  'A friendly Facebook group to swap tips and tell us what to build next.';
